import { useEffect } from 'react';
import IconClock16 from '@warp-ds/icons/react/clock-16';

import { createRawTimeValues } from '../../../../util/calendar';

import { CustomSelect } from '../../common/CustomSelect';

import styles from './TimePicker.module.css';
import { isSameDay } from '../../../../util/calendar';

type TimePickerProps = {
    pickupTime: string;
    returnTime: string;
    pickupDate: Date;
    returnDate: Date;
    onPickupTimeChange: (value: string) => void;
    onReturnTimeChange: (value: string) => void;
    interval?: number;
};

export const TimePicker = ({
    pickupTime,
    returnTime,
    pickupDate,
    returnDate,
    onPickupTimeChange,
    onReturnTimeChange,
    interval = 30,
}: TimePickerProps) => {
    const allTimes = createRawTimeValues(interval);
    const sameDay = isSameDay(pickupDate, returnDate);

    useEffect(() => {
        if (!sameDay || !pickupTime || !returnTime) return;

        if (returnTime <= pickupTime) {
            const next = allTimes.find((time) => time > pickupTime);
            if (next && next !== returnTime) {
                onReturnTimeChange(next);
            }
        }
    }, [pickupTime, returnTime, sameDay, interval, onReturnTimeChange]);

    const returnTimeOptions = sameDay ? allTimes.filter((time) => time > pickupTime) : allTimes;

    const formatOptions = (times: string[]) =>
        times.map((time) => ({
            value: time,
            label: time,
            icon: <IconClock16 aria-hidden />,
        }));

    return (
        <div className={styles.timePicker}>
            <CustomSelect
                dropDirection="up"
                relative
                hideLabelOnSmallScreen={false}
                fullscreenTitle="Når skal bilen hentes?"
                triggerLabel="Hentetid"
                value={pickupTime}
                onChange={onPickupTimeChange}
                options={formatOptions(allTimes)}
            />
            <CustomSelect
                dropDirection="up"
                relative
                hideLabelOnSmallScreen={false}
                fullscreenTitle="Når skal bilen leveres?"
                triggerLabel="Leveringstid"
                value={returnTime}
                onChange={onReturnTimeChange}
                options={formatOptions(returnTimeOptions)}
            />
        </div>
    );
};
